/**
 * VerifiedBadge — subtle teal check ring shown next to writer names
 * when their `verification_tier` is trusted or verified. Sized for
 * article headers, cards, and Follow buttons.
 */
import { CheckCircle2 } from "lucide-react";

export default function VerifiedBadge({
  verified,
  size = "sm",
  className = "",
  testId = "verified-badge",
}) {
  if (!verified) return null;
  const dims = { xs: "w-3 h-3", sm: "w-3.5 h-3.5", md: "w-4 h-4", lg: "w-5 h-5" }[size] || "w-3.5 h-3.5";
  return (
    <span
      className={`inline-flex items-center text-teal-600 ${className}`}
      title="Verified writer"
      aria-label="Verified writer"
      data-testid={testId}
    >
      <CheckCircle2 className={dims} />
    </span>
  );
}
